<template>
  <div>
    <div class="columns breadcrumb" @click="onBreadcrumbClick">
      <LsIcon class="chevron" type="chevron" size="md" />
      <h2>{{ title }}</h2>
    </div>
    <div class="columns">
      <div class="column is-half-desktop">
        <LawnTreatmentWhyViewComponent v-if="step === 1" @advanceStep="advanceStep" />
        <LawnTreatmentWhenViewComponent
          v-if="step === 2"
          :price="servicePrice"
          @submitRequest="submitRequest"
        />
        <LawnTreatmentConfirmationViewComponent v-if="step === 3" />
        <LsFAQ
          v-if="step < 3"
          :data="faqData"
          :with-additional-questions="enableFAQCallSupportBox"
          class="faq-section"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { lsFilters, lsI18nService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import LsFAQ from '@/components/LsFAQ/LsFAQ.vue';
import LawnTreatmentWhyViewComponent from './components/LawnTreatmentWhyViewComponent.vue';
import LawnTreatmentWhenViewComponent from './components/LawnTreatmentWhenViewComponent.vue';
import LawnTreatmentConfirmationViewComponent from './components/LawnTreatmentConfirmationViewComponent.vue';
import { ORDER_SERVICES__SUBMIT_PRICED_LTRS_SERVICE } from '@/store/types';
import { mapActions, mapState } from 'vuex';
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';

export default {
  name: 'LawnTreatmentView',
  components: {
    LsFAQ,
    LawnTreatmentWhyViewComponent,
    LawnTreatmentWhenViewComponent,
    LawnTreatmentConfirmationViewComponent,
    LsIcon,
  },
  props: {
    propertyId: VueTypes.string.isRequired,
    pricing: VueTypes.object.isRequired,
    servicePromoId: VueTypes.number,
  },
  data() {
    return {
      step: 1,
      faqData: [
        {
          title: 'When should I start treatment?',
          content:
            'For best results, we currently offer and recommend a year-round treatment for comprehensive fertilization and weed control. This is a reoccurring service, every 4-6 weeks. Our pro will customize your service to your lawn needs on each treatment.',
        },
        {
          title: 'When is the first service?',
          content: lsI18nService.translate('lawnTreatment.whenIsFirstServiceAnswer'),
        },
        {
          title: 'Can I cancel anytime?',
          content:
            'You can cancel anytime. You are never charged until after the service is completed. However, we recommend at least 8 treatments to see the best results.',
        },
      ],
    };
  },
  computed: {
    ...mapState(['featureFlags']),
    enableFAQCallSupportBox() {
      return this.featureFlags.flags['new_ltrs_flow_additional_questions'];
    },
    title() {
      if (this.step === 2) return 'Schedule Service';
      if (this.step === 3) return 'Return to Dashboard';
      return 'About Lawn Treatment';
    },
    servicePrice() {
      return lsFilters.currency({ amount: this.pricing.price });
    },
  },
  methods: {
    ...mapActions([ORDER_SERVICES__SUBMIT_PRICED_LTRS_SERVICE]),
    advanceStep() {
      this.step++;
    },
    onBreadcrumbClick() {
      if (this.step === 2) {
        this.step--;
        return;
      }

      this.$router.go(-1);
    },
    submitRequest() {
      this[ORDER_SERVICES__SUBMIT_PRICED_LTRS_SERVICE]({
        property_id: this.propertyId,
        service_id: 2, // fertilization/aeration
        price_id: this.pricing.price_id,
        starts_at: null,
        service_promo_id: this.servicePromoId,
        onSuccess: () => {
          this.step++;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  padding: 10px;
  display: flex;
  height: 44px;
  margin-bottom: 4px;

  .chevron {
    transform: rotate(180deg);
    margin: 4px 30px 30px 0;
  }

  h2 {
    font-size: 16px;
    line-height: 27px;
  }
}

.faq-section {
  margin-top: 40px;
}
</style>
